import { Col, Modal, Row } from 'antd';
import React, { useState } from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../common/constants';
import AgenciesContent from './AgenciesContent';
import AgenciesContact from './contacts/AgenciesContacts';

const Teams = () => {
  const [agencyId, setAgencyId] = useState(null);
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  const [modalVisible, setModalVisible] = useState(false);
  const [title, setTitle] = useState();
  return (
    <div id="global-agency-table" className="global-agency-table">
      {!isDesktopViewport && (
        <>
          <div id="page-header" className="page-header text-primary">
            Teams
            <div id="sub-header" />
          </div>
        </>
      )}
      <Row
        id="global-agency-table-wrapper"
        className="global-agency-table-wrapper"
        gutter={isDesktopViewport ? 10 : [16, 16]}
      >
        <Col id="agencies-content-col" span={isDesktopViewport ? 12 : 24}>
          <AgenciesContent
            setAgencyId={setAgencyId}
            agencyId={agencyId}
            setModalVisible={setModalVisible}
            setTitle={setTitle}
          />
        </Col>
        {isDesktopViewport ? (
          <Col span={12}>
            <AgenciesContact agencyId={agencyId} />
          </Col>
        ) : (
          <>
            <div id="agency-contact-modal" />
            <Modal
              maskClosable={false}
              getContainer={() =>
                // eslint-disable-next-line no-undef
                document.getElementById('agency-contact-modal')
              }
              width="100vw"
              title={title}
              open={modalVisible}
              footer={null}
              destroyOnHidden
              onCancel={() => setModalVisible(false)}
            >
              <AgenciesContact agencyId={agencyId} />
            </Modal>
          </>
        )}
      </Row>
    </div>
  );
};

export default Teams;
